import { useDispatch, useSelector } from 'react-redux';
import cls from './Final.module.scss';
import { RootState } from '../../shared/redux/store';
import { useEffect, useState } from 'react';
import { Share } from '../../shared/ui/Share/Share';
import offerImg from '../../shared/assets/images/folder.png';
import { sounds } from '../../shared/ui/Sound/assets';
import final1Btn from '../../shared/assets/images/final1-button.svg';
import final2Btn from '../../shared/assets/images/final2-button.svg';
import final3Btn from '../../shared/assets/images/final3-button.svg';
import final4Btn from '../../shared/assets/images/final4-button.svg';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import { newGame } from '../../shared/redux/game/slice';

const finalText = [
  ['Ты потерялся во льдах!', 'Или просто пошёл своей дорогой.', 'Может, море – это не твоё?!'],
  [
    'Ты напоролся на лёд!',
    'Но не надо паники!',
    'Мёрзнуть в воде не придётся.',
    'К тебе уже едут!',
  ],
  [
    'Ты достиг максимальной мощности!',
    'Но не смог правильно ей воспользоваться и застрял.',
    'С кем не бывает… Сыграешь снова?',
  ],
  [
    'Ледокол, который смог!',
    'Ты прошёл через все арктические льды и открыл путь другим кораблям.',
    'Поздравляем!',
  ],
];

export const Final = () => {
  const dispatch = useDispatch();
  const { currentLevel, isWin } = useSelector((state: RootState) => state.game);

  const isSound = useSelector((state: RootState) => state.page.isSound);
  const [showOffer, setShowOffer] = useState(false);
  const [currentContent, setCurrentContent] = useState({
    text: finalText[0],
    cls: cls.Final1,
    buttonImg: final1Btn,
  });

  useEffect(() => {
    if (isWin) {
      if (isSound) {
        sounds.final_best.play();
      }
      setCurrentContent({
        text: finalText[3],
        cls: cls.Final4,
        buttonImg: final4Btn,
      });
    } else {
      if (currentLevel === 1) {
        if (isSound) {
          sounds.final_bad.play();
        }
        setCurrentContent({
          text: finalText[0],
          cls: cls.Final1,
          buttonImg: final1Btn,
        });
      } else if (currentLevel === 2) {
        if (isSound) {
          sounds.final_good.play();
        }
        setCurrentContent({
          text: finalText[1],
          cls: cls.Final2,
          buttonImg: final2Btn,
        });
      } else if (currentLevel === 3) {
        if (isSound) {
          sounds.final_good.play();
        }
        setCurrentContent({
          text: finalText[2],
          cls: cls.Final3,
          buttonImg: final3Btn,
        });
      }
    }
  }, [currentLevel, isWin]);

  useEffect(() => {
    setTimeout(() => {
      setShowOffer(true);
    }, 5000);
  }, []);

  const soundPlay = () => {
    if (isSound) {
      sounds.btn.play();
    }
  };

  const getStyleP = () => {
    if (window.innerHeight > 550) {
      return { top: '12%' };
    } else {
      return { top: '70px' };
    }
  };

  return (
    <div className={`${cls.Final} ${currentContent.cls}`}>
      <div className="text-container" style={getStyleP()}>
        <p className="text-bg-p">
          {currentContent.text.map((el) => (
            <>
              {el} <br />
            </>
          ))}
        </p>
        <p>
          {currentContent.text.map((el) => (
            <>
              {el} <br />
            </>
          ))}
        </p>
      </div>

      <Share style={{ bottom: '115px' }} />

      <button>
        <img
          alt="btn"
          src={currentContent.buttonImg}
          onClick={() => {
            soundPlay();
            dispatch(setPage(Pages.GAME));
            dispatch(newGame());
          }}
        />
      </button>

      {showOffer && (
        <div className={cls.offerContainer}>
          <img alt="Other game" src={offerImg} className={cls.offerImg} />
          <a
            href="https://memesis.ru/russia21/"
            target="_blank"
            rel="noreferrer"
            className={cls.russiaLink}>
            <div onClick={soundPlay}></div>
          </a>
          <a
            href="https://memesis.ru/unity/"
            target="_blank"
            rel="noreferrer"
            className={cls.unityLink}>
            <div onClick={soundPlay}></div>
          </a>
          <a
            href="https://memesis.ru/wakeup/"
            target="_blank"
            rel="noreferrer"
            className={cls.wakeupLink}>
            <div onClick={soundPlay}></div>
          </a>
          <div
            className={cls.closeOffer}
            onClick={() => {
              soundPlay();
              setShowOffer(false);
            }}></div>
        </div>
      )}
    </div>
  );
};
